module.exports = __webpack_public_path__ + "fonts/AdelleSansSAGE-Bold.44051eae.woff";